import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import CorpartCard from "../Card/CorpartCard";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// JSON Data with 24 items for each tab
const data = {
  Makes: [
    { name: "Mazda", count: 2431, url: "/makes/mazda" },
    { name: "Toyota", count: 8219, url: "/makes/toyota" },
    { name: "Honda", count: 7105, url: "/makes/honda" },
    { name: "Nissan", count: 5642, url: "/makes/nissan" },
    { name: "Suzuki", count: 3842, url: "/makes/suzuki" },
    { name: "Hyundai", count: 6204, url: "/makes/hyundai" },
    { name: "Kia", count: 4112, url: "/makes/kia" },
    { name: "Mitsubishi", count: 2990, url: "/makes/mitsubishi" },
    { name: "Subaru", count: 3745, url: "/makes/subaru" },
    { name: "Lexus", count: 2318, url: "/makes/lexus" },
    { name: "Infiniti", count: 1879, url: "/makes/infiniti" },
    { name: "Acura", count: 3341, url: "/makes/acura" },
    { name: "Ford", count: 39319, url: "/makes/ford" },
    { name: "Chevrolet", count: 28452, url: "/makes/chevrolet" },
    { name: "GMC", count: 11304, url: "/makes/gmc" },
    { name: "Dodge", count: 9742, url: "/makes/dodge" },
    { name: "Chrysler", count: 5804, url: "/makes/chrysler" },
    { name: "Jeep", count: 12003, url: "/makes/jeep" },
    { name: "Cadillac", count: 3599, url: "/makes/cadillac" },
    { name: "Buick", count: 4220, url: "/makes/buick" },
    { name: "BMW", count: 13521, url: "/makes/bmw" },
    { name: "Mercedes-Benz", count: 14115, url: "/makes/mercedes-benz" },
    { name: "Audi", count: 7404, url: "/makes/audi" },
    { name: "Volkswagen", count: 6887, url: "/makes/volkswagen" },
  ],
  Models: [
    { name: "Civic", count: 4300, url: "/models/civic" },
    { name: "Corolla", count: 5000, url: "/models/corolla" },
    { name: "Altima", count: 2900, url: "/models/altima" },
    { name: "Camry", count: 4100, url: "/models/camry" },
    { name: "Accord", count: 3200, url: "/models/accord" },
    { name: "RAV4", count: 2700, url: "/models/rav4" },
    { name: "CR-V", count: 3500, url: "/models/crv" },
    { name: "Elantra", count: 2200, url: "/models/elantra" },
    { name: "Sonata", count: 2100, url: "/models/sonata" },
    { name: "Tucson", count: 2300, url: "/models/tucson" },
    { name: "Sentra", count: 2400, url: "/models/sentra" },
    { name: "Pathfinder", count: 2500, url: "/models/pathfinder" },
    { name: "Murano", count: 2600, url: "/models/murano" },
    { name: "Rogue", count: 2700, url: "/models/rogue" },
    { name: "Explorer", count: 2800, url: "/models/explorer" },
    { name: "F-150", count: 2900, url: "/models/f150" },
    { name: "Escape", count: 3000, url: "/models/escape" },
    { name: "Mustang", count: 3100, url: "/models/mustang" },
    { name: "Malibu", count: 3200, url: "/models/malibu" },
    { name: "Impala", count: 3300, url: "/models/impala" },
    { name: "Tahoe", count: 3400, url: "/models/tahoe" },
    { name: "Equinox", count: 3500, url: "/models/equinox" },
    { name: "Traverse", count: 3600, url: "/models/traverse" },
    { name: "Trailblazer", count: 3700, url: "/models/trailblazer" },
  ],
  Types: [
    { name: "Automobile", count: 2000, url: "/types/automobile" },
    { name: "SUV", count: 2040, url: "/types/suv" },
    { name: "Truck", count: 2080, url: "/types/truck" },
    { name: "Van", count: 2120, url: "/types/van" },
    { name: "Coupe", count: 2160, url: "/types/coupe" },
    { name: "Convertible", count: 2200, url: "/types/convertible" },
    { name: "Wagon", count: 2240, url: "/types/wagon" },
    { name: "Hatchback", count: 2280, url: "/types/hatchback" },
    { name: "Crossover", count: 2320, url: "/types/crossover" },
    { name: "Pickup", count: 2360, url: "/types/pickup" },
    { name: "Sedan", count: 2400, url: "/types/sedan" },
    { name: "Minivan", count: 2440, url: "/types/minivan" },
    { name: "Electric", count: 2480, url: "/types/electric" },
    { name: "Hybrid", count: 2520, url: "/types/hybrid" },
    { name: "Diesel", count: 2560, url: "/types/diesel" },
    { name: "Luxury", count: 2600, url: "/types/luxury" },
    { name: "Sports Car", count: 2640, url: "/types/sports-car" },
    { name: "Off-Road", count: 2680, url: "/types/off-road" },
    { name: "Classic", count: 2720, url: "/types/classic" },
    { name: "Muscle Car", count: 2760, url: "/types/muscle-car" },
    { name: "Compact", count: 2800, url: "/types/compact" },
    { name: "Microcar", count: 2840, url: "/types/microcar" },
    { name: "Roadster", count: 2880, url: "/types/roadster" },
    { name: "Supercar", count: 2920, url: "/types/supercar" },
  ],
  // Featured: Array.from({ length: 24 }, (_, i) => ({
  //   name: `Featured Car ${i + 1}`,
  //   count: 1000 + i * 50,
  //   url: `/featured/${i + 1}`,
  // })),
};

const CopartData = () => {
  const [tab, setTab] = useState("Makes");
  const navigate = useNavigate();

  const renderList = (items) => {
    const chunkSize = Math.ceil(items.length / 4);
    const columns = [];

    for (let i = 0; i < items.length; i += chunkSize) {
      columns.push(items.slice(i, i + chunkSize));
    }

    return (
      <div className="row">
        {columns.map((col, idx) => (
          <div className="col-lg-3" key={idx}>
            <ul>
              {col.map((item, i) => (
                <li
                  key={i}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    tab === "Makes"
                      ? navigate(
                          `/searchbrand?heading=${encodeURIComponent(
                            item?.name
                          )}`
                        )
                      : navigate("/quicksearch", {
                          state: { filter: item.name },
                        })
                  }
                >
                  {item.name} {/* ({item.count.toLocaleString()}) */}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="row mt-5 d-lg-block d-none">
        <div className="col-lg-6 mx-auto">
          <div className="site-heading text-center flex">
            <i className="flaticon-drive site-title-tagline"></i>
            <span className="site-title-tagline">
              Wholesale auctions: Choose from over 300k vehicle inventory
            </span>
            <div className="heading-divider"></div>
          </div>
        </div>
      </div>

      <div className="container mb-4">
        <Tabs
          activeKey={tab}
          onSelect={(k) => setTab(k)}
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          {Object.keys(data).map((tabKey) => (
            <Tab eventKey={tabKey} title={tabKey} key={tabKey}>
              {renderList(data[tabKey])}
            </Tab>
          ))}
        </Tabs>
      </div>

      <CorpartCard />
    </>
  );
};

export default CopartData;
